import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Podstavka: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Raznoe/kP6260014.jpg"},
        {src: "/image/Schema/kP6250006.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Подставка под чашку в марокканском стиле",
        "Подставка под чашку из бисера в марокканском стиле. Каркас сделан из проволоки и крупного бисера, а внутри натянуты бисерные нити из мелкого и среднего."
    )

    return <>
        <h2>Подставка под чашку в марокканском стиле</h2>

        <div className="row">
            <div className="col-md-12">
                <p><img src="/image/Raznoe/mP6260014.jpg"
                        width="227" height="170"
                        className="pic-left img-rounded"
                        alt="Подставка под чашку в марокканском стиле"
                        id="image-0"
                        onClick={viewImage}
                />
                    Марокканский стиль - это одно из самых экзотичных смешений нескольких культурных традиций&nbsp;—
                    североафриканской (мавританской, арабской, берберской) и европейской (римской, испанской,
                    английской, но в основном французской).</p>

                <p>Основная идея создать вибрирующую игру цвета. Это гармоничное столкновение живых оттенков - действует
                    возбуждающе, задает интерьеру характерную импульсивность.</p>

                <p>Кроме чёрного и холодного белого, популярны тона здешних песков и почв: золотистый, жёлтая охра,
                    песочный, бежевый, розовато-красный и умбра. В марокканской палитре - все оттенки зелёного и синего.
                    А ещё яркий жёлтый, нежный розовый, солнечный оранжевый, насыщенный красный и ослепительный
                    фиолетовый.</p>

                <p>А ещё марокканский стиль предполагает неожиданно разнообразие дизайна: от наивного до утончённого, с
                    символами и узорами, повторяющимися в различных формах. Этот стиль&nbsp;— тёплый, уютный и в то же
                    время - яркий и самобытный.</p>

                <p>Для изготовления этой необычной подставки нам понадобится: разноцветный бисер разного размера,
                    проволока, нитки или леска. Чтобы бисер набирать на нить без иголки, ее кончик нужно смазать
                    клеем.</p>

                <img src="/image/Schema/mP6250006.jpg"
                     width="227" height="219"
                     className="pic-right img-rounded"
                     alt="Подставка под чашку в марокканском стиле"
                     id="image-1"
                     onClick={viewImage}
                />
                <p>Для подставки размером 7х7 см возьмем проволоку длиной около 35 см и нанизываем бисер в определенном
                    порядке, отделяя каждую сторону бусинкой. Скрепляем концы проволоки, чтобы получилась квадратная
                    рамка. Привязываем к одной из ее сторон нитку и нанизываем бисер пока отрезок не будет равен длине
                    рамки. Закрепляем узелком нить на противоположной стороне проволочной рамки. Повторяем операцию до
                    тех пор пока не заполним рамку бисерными нитями. На каждую отдельную нить нанизываем бусины одного
                    вида.</p>

            </div>
        </div>
        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>
        ;
};

export default Podstavka;

